<template>
  <div class="home">
    <hooper :settings="bannerSettings" style="height: 170px;  pointer-events: none;"  class="hero hidden-md-and-up">
      <slide v-for="banner in banners" :key="banner.id">
        <div class="hero hidden-md-and-up"> <!-- Mobile -->
          <v-img height="170" :src="getImage(banner.images)" :lazy-src="getImage(banner.images)" style="width: 100%"></v-img>
        </div>
        <div class="hero hidden-sm-and-down"> <!-- Desktop -->
          <v-img height="350" width="100%" :src="getImage(banner.images)" responsive :lazy-src="getImage(banner.images)"></v-img>
        </div> 
      </slide>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>
    <hooper :settings="bannerSettings" style="height: 350px;  pointer-events: none;"  class="hero hidden-sm-and-down">
      <slide v-for="banner in banners" :key="banner.id">
        <div class="hero hidden-md-and-up"> <!-- Mobile -->
          <v-img height="130" :src="getImage(banner.images)" :lazy-src="getImage(banner.images)"></v-img>
        </div>
        <div class="hero hidden-sm-and-down"> <!-- Desktop -->
          <v-img height="350" width="100%" :src="getImage(banner.images)" responsive :lazy-src="getImage(banner.images)"></v-img> 
        </div>
      </slide>
      <hooper-pagination slot="hooper-addons"></hooper-pagination>
    </hooper>
    <div class="hidden-md-and-up container">
      <b class="subtitle is-5 label" style="padding-left: 15px;">Upcoming Events</b>
      <hooper :settings="m_eventSettings" style="height: 190px; pointer-events: none;">
        <slide v-for="event in events" :key="event.id">
          <event :event="event" style="pointer-events: auto;"/>
        </slide>
      </hooper>
    </div>
    <div class="hidden-sm-and-down container">
      <b class="title is-3 label" style="padding-right: 5px;">Upcoming Events</b>
      <hooper :settings="eventSettings" style="height: 240px;  pointer-events: none;">
        <slide v-for="event in events" :key="event.id">
          <event :event="event" style="pointer-events: auto;"/>
        </slide>
      </hooper>
    </div>
    <div class="hidden-sm-and-down container">
      <b class="title is-3 label">Featured Products</b>
      <hooper :settings="productSettings" style="height: 350px; pointer-events: none;">
        <slide v-for="product in featured_products" :key="product.id" >
          <product :product="product" style="pointer-events: auto;"/>
        </slide>
        <hooper-navigation slot="hooper-addons" style="pointer-events: auto"></hooper-navigation>
      </hooper>
    </div>
    <div class="hidden-md-and-up container">
      <b class="title is-4 label">Featured Products</b>
      <hooper :settings="m_productSettings" style="height: 290px; pointer-events: none;">
        <slide v-for="product in featured_products" :key="product.id">
          <product :product="product" style="pointer-events: auto;"/>
        </slide>
        <hooper-navigation slot="hooper-addons" style="pointer-events: auto"></hooper-navigation>
      </hooper>
    </div>
    <div class="hidden-sm-and-down container" v-for="layout in main_layouts" :key="layout.id">
      <span v-if="layout.category_target_slug === 'footwear'">
        <b class="title is-3 label">{{ layout.name }}</b>
        <hooper :settings="productSettings" style="height: 350px; pointer-events: none;">
          <slide v-for="product in footwear_products" :key="product.slug">
            <product :product="product" style="pointer-events: auto;"/>
          </slide>
          <hooper-navigation slot="hooper-addons" style="pointer-events: auto"></hooper-navigation>
        </hooper>
      </span>
      <span v-if="layout.category_target_slug === 'entertainment'">
        <b class="title is-3 label">{{ layout.name }}</b>
        <hooper :settings="productSettings" style="height: 350px; pointer-events: none;">
          <slide v-for="product in entertainment_products" :key="product.slug">
            <product :product="product" style="pointer-events: auto;"/>
          </slide>
          <hooper-navigation slot="hooper-addons" style="pointer-events: auto"></hooper-navigation>
        </hooper>
      </span>
    </div>
    <div class="hidden-md-and-up container" v-for="layout in main_layouts" :key="layout.slug">
      <span v-if="layout.category_target_slug === 'entertainment'">
        <b class="title is-3 label" style="padding-right: 20px;">{{ layout.name }}</b>
        <hooper :settings="m_productSettings" style="height: 290px; pointer-events: none;">
          <slide v-for="product in entertainment_products" :key="product.slug">
            <product :product="product" style="pointer-events: auto;"/>
          </slide>
          <hooper-navigation slot="hooper-addons" style="pointer-events: auto"></hooper-navigation>
        </hooper>
      </span>
    </div>
    <v-divider></v-divider>
    <!-- <div class="ad-container">
      <Adsense
        data-ad-client="ca-pub-4281663378318259"
        data-ad-slot="5736366973"
        data-ad-format="auto"
        :data-full-width-responsive="true"
      >
      </Adsense>
    </div> -->
  </div>
</template>

<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
</script>
<script>
  import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper'
  import 'hooper/dist/hooper.css'
  import {db} from '@/firebase'

  export default {
    name: 'home',
    data: () => ({
      main_layouts: [],
      footwear_products: [],
      entertainment_products: [],
      featured_products: [],
      banners: [],
      events: [],
      bannerSettings: {
        itemsToShow: 1,
        rtl: true,
        centerMode: false,
        autoPlay: true,
        playSpeed: 5000
      },
      eventSettings: {
        itemsToShow: 5,
        rtl: false,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 4000,
        centerMode: true
      },
      m_eventSettings: {
        itemsToShow: 2,
        rtl: false,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 7000
      },
      productSettings: {
        itemsToShow: 4,
        rtl: false,
        infiniteScroll: true,
      },
      m_productSettings: {
        itemsToShow: 2,
        rtl: false,
        infiniteScroll: true,
      }  
    }),
    methods: {
      getImage(images){
        return images[0]
      }
    },
    components: {
      Hooper,
      Slide,
      HooperPagination,
      HooperNavigation
    },
    firestore:{
      main_layouts: 
      db.collection('main_layouts')
      .where('status','==',1)
      .orderBy('order', 'desc'),
      footwear_products: 
      db.collection('products')
      .where('Cat_slug','==','footwear')
      .where('status','==',1)
      .where('priority','==',1)
      .limit(10),
      entertainment_products: 
      db.collection('products')
      .where('Cat_slug','==','entertainment')
      .where('status','==',1)
      .where('priority','==',1)
      .limit(10),
      featured_products: db.collection('products')
      .where('product_key','==','featured'),
      banners: db.collection('banners'),
      events: db.collection('events')
    }
  }
</script>
